// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__vVlK-","rootSmall":"AddTileButton_rootSmall__v9TcM"};